//mport "../src/css/filtro_select.css";

import certBasic from '../src/imgs/lateral_sections/certificacion_basica.svg';
import certIntermedia from '../src/imgs/lateral_sections/certificacion_intermedia.svg';
import certAvanzada from '../src/imgs/lateral_sections/certificacion_avanzada.svg';

import curLinea from '../src/imgs/lateral_sections/cursos_en_linea.svg';
import curMooc from '../src/imgs/lateral_sections/cursos_mooc.svg';
import curDiplomado from '../src/imgs/lateral_sections/diplomados.svg';

import doctorado from '../src/imgs/lateral_sections/doctorado.svg';
import maestria from '../src/imgs/lateral_sections/maestrias.svg';

export const FiltroCardsCertificados = () => {

  return (
    <>
    <div className="Filtro">
    <div className="Filtro_region" onChange={(e)=>{filtro(e.target.value)}}>
    
      <select>
        <option id='#filtro3'value={'3'}>Mostrar todos</option>
        <option id='#filtro1' value={'1'}>INAP central</option>
        <option id='#filtro2'value={'2'}>Delegación Petén</option>
        <option id='#filtro4'value={'4'}>Delegación Regional Norte</option>
      </select>
    </div>
    </div>
    </>

  )
}
export const FiltroCardsCursos= () => {

  return (
    
    <>
    <div className="Filtro">
    <div className="Filtro_region" onChange={(e)=>{filtroc(e.target.value)}}>
    
      <select>
        <option id='#filtro3'value={'3'}>Mostrar todos</option>
        <option id='#filtro1' value={'1'}>INAP central</option>
        <option id='#filtro2'value={'2'}>Delegación Petén</option>
        <option id='#filtro4'value={'4'}>Delegación Regional Norte</option>
      </select>
    </div>
    </div>
    </>


  )
}
export const FiltroCardsPos = () => {

  return (
    <>
    <div className="Filtro">
    <div className="Filtro_region" onChange={(e)=>{filtrop(e.target.value)}}>
    
      <select>
        <option id='#filtro3'value={'3'}>Mostrar todos</option>
        <option id='#filtro1' value={'1'}>INAP central</option>
        <option id='#filtro2'value={'2'}>Delegación Petén</option>
        <option id='#filtro4'value={'4'}>Delegación Regional Norte</option>
      </select>
    </div>
    </div>
    </>


  )
}
export function filtro(valor){
  if(valor=="1"){
    document.querySelectorAll('[id^="11"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="111"]').forEach(element => {
      element.style.display = "none";
          });

          document.querySelectorAll('[id^="1111"]').forEach(element => {
            element.style.display = "none";
                });
    
    document.querySelectorAll('[id^="12"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="122"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="1222"]').forEach(element => {
            element.style.display = "none";
                });
    document.querySelectorAll('[id^="13"]').forEach(element => {
      element.style.display = "block";
          });
        document.querySelectorAll('[id^="133"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="1333"]').forEach(element => {
            element.style.display = "none";
                });
    


  }

  if(valor=="2"){
    document.querySelectorAll('[id^="11"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="111"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1111"]').forEach(element => {
            element.style.display = "none";
                });

    document.querySelectorAll('[id^="12"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="122"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1222"]').forEach(element => {
            element.style.display = "none";
                });
    document.querySelectorAll('[id^="13"]').forEach(element => {
      element.style.display = "none";
          });
        document.querySelectorAll('[id^="133"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1333"]').forEach(element => {
            element.style.display = "none";
                });
    

  }

  if(valor=="3"){

    document.querySelectorAll('[id^="11"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="111"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1111"]').forEach(element => {
            element.style.display = "block";
                });
    
    document.querySelectorAll('[id^="12"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="122"]').forEach(element => {
      element.style.display = "block";
          });

          document.querySelectorAll('[id^="1222"]').forEach(element => {
            element.style.display = "block";
                });
        document.querySelectorAll('[id^="13"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="133"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1333"]').forEach(element => {
            element.style.display = "block";
                });

}

if(valor=="4"){

  document.querySelectorAll('[id^="11"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="111"]').forEach(element => {
          element.style.display = "none";
              });
  document.querySelectorAll('[id^="1111"]').forEach(element => {
    element.style.display = "block";
        });
  
  
  document.querySelectorAll('[id^="12"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="122"]').forEach(element => {
          element.style.display = "none";
          document.querySelectorAll('[id^="1222"]').forEach(element => {
            element.style.display = "block";
                });
              });
      document.querySelectorAll('[id^="13"]').forEach(element => {
    element.style.display = "none";
        });
  document.querySelectorAll('[id^="133"]').forEach(element => {
    element.style.display = "none";
        });

      document.querySelectorAll('[id^="1333"]').forEach(element => {
          element.style.display = "block";
              });

}

}


export function filtroc(valor){
  if(valor=="2"){

    document.querySelectorAll('[id^="14"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="144"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1444"]').forEach(element => {
            element.style.display = "none";
                });
    
    document.querySelectorAll('[id^="15"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="155"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1555"]').forEach(element => {
            element.style.display = "none";
                });
        document.querySelectorAll('[id^="16"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="166"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1666"]').forEach(element => {
            element.style.display = "none";
                });



  }

  if(valor=="1"){

    document.querySelectorAll('[id^="14"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="144"]').forEach(element => {
      element.style.display = "none";
          });
    
          document.querySelectorAll('[id^="1444"]').forEach(element => {
            element.style.display = "none";
                });
    document.querySelectorAll('[id^="15"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="155"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="155"]').forEach(element => {
            element.style.display = "none";
                });
        document.querySelectorAll('[id^="16"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="166"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="1666"]').forEach(element => {
            element.style.display = "none";
                });


  }

  if(valor=="3"){

    document.querySelectorAll('[id^="14"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="144"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1444"]').forEach(element => {
            element.style.display = "block";
                });
    
    document.querySelectorAll('[id^="15"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="155"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1555"]').forEach(element => {
            element.style.display = "block";
                });
        document.querySelectorAll('[id^="16"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="166"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1666"]').forEach(element => {
            element.style.display = "block";
                });

}


if(valor=="4"){

  document.querySelectorAll('[id^="14"]').forEach(element => {
    element.style.display = "none";
        });
  document.querySelectorAll('[id^="144"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="1444"]').forEach(element => {
          element.style.display = "block";
              });
  
  document.querySelectorAll('[id^="15"]').forEach(element => {
    element.style.display = "none";
        });
  document.querySelectorAll('[id^="155"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="1555"]').forEach(element => {
          element.style.display = "block";
              });
      document.querySelectorAll('[id^="16"]').forEach(element => {
    element.style.display = "none";
        });
  document.querySelectorAll('[id^="166"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="1666"]').forEach(element => {
          element.style.display = "block";
              });

}

}

export function filtrop(valor){
  
  if(valor=="2"){

    document.querySelectorAll('[id^="17"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="177"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1777"]').forEach(element => {
            element.style.display = "none";
                });
    
    document.querySelectorAll('[id^="18"]').forEach(element => {
      element.style.display = "none";
          });
    document.querySelectorAll('[id^="188"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1888"]').forEach(element => {
            element.style.display = "none";
                });

 

  }

  if(valor=="1"){
    document.querySelectorAll('[id^="17"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="177"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="1777"]').forEach(element => {
            element.style.display = "none";
                });
    
    document.querySelectorAll('[id^="18"]').forEach(element => {
      element.style.display = "block";
          });
    document.querySelectorAll('[id^="188"]').forEach(element => {
      element.style.display = "none";
          });
          document.querySelectorAll('[id^="1888"]').forEach(element => {
            element.style.display = "none";
                });

  }

  if(valor=="3"){

    document.querySelectorAll('[id^="17"]').forEach(element => {
      element.style.display = "block";
          });

    document.querySelectorAll('[id^="177"]').forEach(element => {
      element.style.display = "block";
          });
          document.querySelectorAll('[id^="1777"]').forEach(element => {
            element.style.display = "block";
                });
   
                document.querySelectorAll('[id^="18"]').forEach(element => {
                  element.style.display = "block";
                      });
    document.querySelectorAll('[id^="188"]').forEach(element => {
      element.style.display = "block";
          });
   
          document.querySelectorAll('[id^="1888"]').forEach(element => {
            element.style.display = "block";
                });

}

if(valor=="4"){

  document.querySelectorAll('[id^="17"]').forEach(element => {
    element.style.display = "none";
        });

  document.querySelectorAll('[id^="177"]').forEach(element => {
    element.style.display = "none";
        });
        document.querySelectorAll('[id^="1777"]').forEach(element => {
          element.style.display = "block";
              });
 

              document.querySelectorAll('[id^="18"]').forEach(element => {
                element.style.display = "none";
                    });
  
  document.querySelectorAll('[id^="188"]').forEach(element => {
    element.style.display = "none";
        });
 

        document.querySelectorAll('[id^="1888"]').forEach(element => {
          element.style.display = "block";
              });

}

}